import CardSystem, { getCardHandler } from '../CardSystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import CardComponent, { DEFAULT_CARD_SCALE } from '../../../Component/Level/Card';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';
import { CardFlip } from 'System/Animation/Clip';
import { BaseCardEvent } from '../../../Prototype/Level/Card/BaseCard';

export default function FlipCardAnimation(system: CardSystem, taskData: ICardStateTaskData): void {
    for (const cardID of taskData.cards) {
        const card = system.getCardByID(cardID);
        const faceUp = taskData.faceUp ?? true;
        const cardComponent = card.getComponent(CardComponent);
        getCardHandler(card).setCardFaceUp(!faceUp);
        card.emit(BaseCardEvent.FLIP_START);

        system.taskQueue.queue(
            new AnimationClipTask(
                new CardFlip(card, {
                    faceUp: true,
                    rotation: cardComponent.rotation,
                    scale: DEFAULT_CARD_SCALE,
                    delay: taskData.delayByCardID?.[cardID],
                }),
                true
            )
        );
    }
}
